export default __webpack_public_path__ + "static/media/11.2e99ff76.jpg";